@import (reference) '../../../../../constants/spacing.module.less';

.when-pill {
  align-self: flex-start;
  background-color: var(--grey-200);
  border-radius: 100px;
}
